import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const TahfidzDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Tahfidz",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Tanggal</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.tanggal ?? Date.now()).format("DD MMMM YYYY")}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Nilai</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.nilai ? state.nilai : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Keterangan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.tambahanKeterangan ? state.tambahanKeterangan : "---"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Hafalan Baru</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.hafalanBaru ? state.hafalanBaru : "---"} halaman,{" "}
            {state.rincianHafalan ? state.rincianHafalan : "---"}
          </div>
        </div>
      </div>
    </>
  );
};
